module.exports = __webpack_public_path__ + "static/boston-background-884c8d9ead73f235d207d27911a92ff6.jpg";